export class Details {
    // Taken from https://css-tricks.com/how-to-animate-the-details-element-using-waapi/
    // If we didn't need to animate the element, this whole file could be deleted!
    #detailsElement: HTMLDetailsElement;
    #summary: HTMLElement | null;
    #content: HTMLElement | null;
    #isExpanding: boolean;
    #isClosing: boolean;
    #animation: Animation | null;
    #userPrefersReducedMotion: boolean;

    constructor(el: HTMLDetailsElement) {
        this.#detailsElement = el;
        this.#summary = el.querySelector<HTMLElement>('summary');
        this.#content = el.querySelector<HTMLElement>('[data-accordion="content"]');
        this.#animation = null;
        this.#isClosing = false;
        this.#isExpanding = false;
        this.#userPrefersReducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        ).matches;
        if (this.#summary && !this.#userPrefersReducedMotion) {
            this.#summary.addEventListener('click', e => {
                this.#handleClick(e);
            });
        }
    }

    #handleClick(event: Event) {
        event.preventDefault();
        this.#detailsElement.style.overflow = 'hidden';
        if (this.#isClosing || !this.#detailsElement.open) {
            this.#open();
        } else if (this.#isExpanding || this.#detailsElement.open) {
            this.#shrink();
        }
    }

    #shrink() {
        if (this.#summary && this.#content) {
            this.#isClosing = true;
            const startHeight = `${this.#detailsElement.offsetHeight}px`;
            const endHeight = `${this.#summary?.offsetHeight}px`;

            if (this.#animation) {
                this.#animation.cancel();
            }

            this.#animation = this.#detailsElement.animate(
                {
                    // Set the keyframes from the startHeight to endHeight
                    height: [startHeight, endHeight],
                },
                {
                    duration: 400,
                    easing: 'ease-out',
                }
            );

            this.#animation.onfinish = () => this.#onAnimationFinish(false);
            this.#animation.oncancel = () => (this.#isClosing = false);
        }
    }

    #open() {
        this.#detailsElement.style.height = `${this.#detailsElement.offsetHeight}px`;
        this.#detailsElement.open = true;
        window.requestAnimationFrame(() => this.#expand());
    }

    #expand() {
        if (this.#summary && this.#content) {
            this.#isExpanding = true;
            const startHeight = `${this.#detailsElement.offsetHeight}px`;
            const endHeight = `${
                this.#summary.offsetHeight + this.#content.offsetHeight
            }px`;

            if (this.#animation) {
                this.#animation.cancel();
            }

            this.#animation = this.#detailsElement.animate(
                {
                    height: [startHeight, endHeight],
                },
                {
                    duration: 400,
                    easing: 'ease-out',
                }
            );
            this.#animation.onfinish = () => this.#onAnimationFinish(true);
            this.#animation.oncancel = () => (this.#isExpanding = false);
        }
    }

    #onAnimationFinish(isOpen: boolean) {
        this.#detailsElement.open = isOpen;
        this.#animation = null;
        this.#isClosing = false;
        this.#isExpanding = false;
        this.#detailsElement.style.height = this.#detailsElement.style.overflow = '';
    }
}
export default function accordion(detailsElements: HTMLDetailsElement[]) {
    detailsElements.forEach(detailsElement => {
        new Details(detailsElement);
    });
}
